export default (
  state = {
    catalogItems: [],
    // selected category id is the filter below. 0 means all categories
    catalogCategoryFilter: 0,
    allCategories: [],
    allFamilies: [],
    catalogItemsAddedToDealTable: [],
    priceListId: 0,
    userQuotes: [],
    userQuotesStatusFilterData: [],
    quoteDetails: {},
    showCatalogPanel: false,
    quotetermTemplates: [],
    footerActionBar: {},
    quotetermTemplate: "",
    quotetermFormFields: [],
  },
  action,
) => {
  switch (action.type) {
    /*
    ===============================
        Quote Details Page
    ===============================
    */
    case "QUOTE_LIST_BY_USER":
      return {
        ...state,
        userQuotes: action.payload.data,
        userQuotesStatusFilterData: action.payload.statusData,
      };
    case "QUOTE_DETAILS":
      return {
        ...state,
        quoteDetails: action.payload,
      };
    case "SHOW_CATALOG_PANEL":
      return {
        ...state,
        showCatalogPanel: true,
      };
    case "TOGGLE_CATALOG_PANEL": {
      const panelStatus = !state.showCatalogPanel;
      return {
        ...state,
        showCatalogPanel: panelStatus,
      };
    }

    /*
    ===============================
          Catalog Section
    ===============================
    */
    case "ALL_CATEGORIES":
      return {
        ...state,
        allCategories: action.payload,
      };
    case "ALL_FAMILIES":
      return {
        ...state,
        allFamilies: action.payload,
      };
    case "GET_CATALOG_LIST":
      // The below method will override the existing value
      return {
        ...state,
        catalogItems: action.payload.catalogList,
      };
    case "UPDATE_CATALOG_LIST":
      return {
        ...state,
        catalogItems: action.payload,
      };
    case "CATALOG_CATEGORY_FILTER":
      return {
        ...state,
        catalogCategoryFilter: action.payload,
      };

    /*
    ===============================
      Quoteterm Functions
    ===============================
    */
    case "GET_QUOTETERM_TEMPLATE":
      return { ...state, quotetermTemplate: action.payload };
    case "UPDATE_QUOTETERM_TEMPLATE": {
      const template = action.payload;
      if (Object.keys(action.payload).length !== 0) {
        template.quoteID = state.quoteDetails.id;
      }
      return { ...state, quotetermTemplate: template };
    }
    case "UPDATE_QUOTETERM_FORMFIELDS":
      return { ...state, quotetermFormFields: action.payload };
    case "UPDATE_QUOTETERM_TEMPLATELIST":
      return { ...state, quotetermTemplates: action.payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/QuotesReducer.js